import React from "react";
import { Image, Modal, Space, Typography } from "antd";
import { NormalizedReward } from "../utils/rewards";
import { dashboardPalette } from "../theme";

// ══════════════════════════════════════════════════════════════
// POPUP DE CANJE (agregado 01/09/2026)
//
// Muestra cómo se canjea una recompensa: una imagen opcional
// (QR, cupón, logo del comercio) y un texto con los pasos, ambos
// cargados desde el panel de Admin. Es solo presentación: no
// modifica el estado de la recompensa ni llama a Firestore.
// ══════════════════════════════════════════════════════════════

interface RewardRedeemModalProps {
  reward: NormalizedReward | null;
  open: boolean;
  onClose: () => void;
}

const RewardRedeemModal: React.FC<RewardRedeemModalProps> = ({
  reward,
  open,
  onClose,
}) => {
  if (!reward) {
    return null;
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={420}
      title={
        <Typography.Text
          strong
          style={{ color: dashboardPalette.headerBlue, fontSize: 18 }}
        >
          {reward.redeemTitle || `Cómo canjear: ${reward.name}`}
        </Typography.Text>
      }
      //styles={{ content: { borderRadius: 24 } }}
    >
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        {reward.redeemImage ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Image
              src={reward.redeemImage}
              alt={`Canje de ${reward.name}`}
              width={200}
              style={{ borderRadius: 12, objectFit: "contain" }}
              preview={{ mask: "Ampliar" }}
            />
          </div>
        ) : null}

        <Typography.Paragraph
          style={{
            margin: 0,
            whiteSpace: "pre-line", // respeta los saltos de línea del admin
            color: dashboardPalette.textDark,
          }}
        >
          {reward.redeemInstructions ||
            "Acercate al stand del Desafío con este premio para canjearlo."}
        </Typography.Paragraph>
      </Space>
    </Modal>
  );
};

export default RewardRedeemModal;